import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Home from './screens/Home/home';
import Pay from './screens/Pay/pay';
import PayCard from './screens/PayCard/payCard';
import PayPix from './screens/PayPix/payPix';
import Receipt from './screens/Receipt/receipt';
import ViewTicket from './screens/ViewTicket/viewTicket';
import Ticket from './screens/Ticket/ticket';
import { Provider, positions } from 'react-alert';
import InfoIcon from './components/icons/InfoIcon';
import SuccessIcon from './components/icons/SuccessIcon';
import CloseIcon from './components/icons/CloseIcon';
import ErrorIcon from './components/icons/ErrorIcon';
import Error from './screens/Error/error';
import TimeoutPix from './screens/PayPix/timeoutPix';

const rootElement = document.getElementById("root");

const options = {
  timeout: 3000,
  position: positions.TOP_RIGHT
};

const alertStyle = {
  backgroundColor: '#151515',
  color: 'white',
  padding: '10px',
  borderRadius: '3px',
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  boxShadow: '0px 2px 2px 2px rgba(0, 0, 0, 0.03)',
  fontFamily: 'Segoe UI',
  width: '300px',
  boxSizing: 'border-box'
}

const buttonStyle = {
  marginLeft: '20px',
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  color: '#FFFFFF'
}

const AlertTemplate = ({ message, options, style, close }: any) => {
  return (
    <div style={{ ...alertStyle, ...style }}>
      {options.type === 'info' && <InfoIcon />}
      {options.type === 'success' && <SuccessIcon />}
      {options.type === 'error' && <ErrorIcon />}
      <span style={{ flex: 2 }}>{message}</span>
      <button onClick={close} style={buttonStyle}>
        <CloseIcon />
      </button>
    </div>
  )
}

ReactDOM.render(
  <Provider template={AlertTemplate} {... options}>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="TK" element={<Ticket />} />
        <Route path="Pay" element={<Pay />} />
        <Route path="PayPix" element={<PayPix />} />
        <Route path="PayCard" element={<PayCard />} />
        <Route path="Receipt" element={<Receipt />} />
        <Route path="ViewTicket" element={<ViewTicket />} />
        <Route path="404TK" element={<Error />} />
        <Route path="*" element={<Error />} />
        <Route path="TimeoutPix" element={<TimeoutPix />} />
      </Routes>
    </BrowserRouter>
  </Provider>,
  rootElement
);

